import { createFileRoute } from "@tanstack/react-router";
import { ResidentBillingPage } from "@/components/app/portal/pages/resident-billing-page";

export const Route = createFileRoute("/family-portal/$residentId/billing")({
  head: () => ({ meta: [{ title: "Billing | People AI" }] }),
  component: FamilyBilling,
});

function FamilyBilling() {
  const { residentId } = Route.useParams();
  return <ResidentBillingPage residentId={residentId} />;
}
